import React, { useState } from 'react';
import styled from 'styled-components';
import { TABLET_WIDTH } from '~~elements/Const';
import FirstBaseHeader from './FirstBaseHeader';
import moment from 'moment';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  letter-spacing: 1px;
  padding-top: 2rem;

  .team {
    .status {
      font-size: 1.2rem;
    }
    .due-date {
      font-size: 1rem;
    }
  }

  .divider {
    border: 1px #222 solid;
    width: 100%;
    height: 0px;
  }

  .intro {
    white-space: break-spaces;
    line-height: 28px;
  }

  @media (max-width: ${TABLET_WIDTH}) {
    align-items: center;
    .team {
      .status {
        text-align: center;
      }
      .due-date {
        text-align: center;
      }
    }
  }
`;

const FirstBaseSubscription = ({ firstBases }) => {
  const [teamIndex, setTeamIndex] = useState(0);

  return (
    <StyledDiv>
      <div className="team">
        {firstBases.length > 0 && (
          <FirstBaseHeader firstBases={firstBases} teamIndex={teamIndex} setTeamIndex={setTeamIndex} />
        )}
        {firstBases.length === 0 ? (
          <div className="status">尚未訂閱</div>
        ) : (
          <>
            <div className="status">已訂閱</div>
            <div className="due-date">使用期限：{moment(firstBases[teamIndex].info.due_date).format('YYYY-MM-DD')}</div>
          </>
        )}
      </div>
      <hr className="divider" />
      <div className="intro">
        {`
        球隊可以透過分析賽事，了解球員近期的表現與訓練的成果是否有效反應在實戰當中。亦可依照過往的數據判斷戰術下達時機與球員調度。 服務提供三種主要功能：

        1. 團隊進階數據 - 透過圖表、表格交互呈現數據表現
        2. 球員成長追蹤 - 了解個體球員在每場比賽中的表現，亦可與其他選手相比優劣
        3. 情境模擬分析 - 透過模擬局數、比數、出局數、壘上狀況，評估球員戰術運用能力與心理素質

        現階段尚未開啟線上訂閱功能，如對此功能有興趣或想深入了解，歡迎透過粉絲專業、電子信箱與我們聯繫，謝謝！
        `}
      </div>
    </StyledDiv>
  );
};

export default FirstBaseSubscription;
